"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DateGeneralHandler", {
    enumerable: true,
    get: function() {
        return DateGeneralHandler;
    }
});
const _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
const _timezone = /*#__PURE__*/ _interop_require_default(require("dayjs/plugin/timezone"));
const _utc = /*#__PURE__*/ _interop_require_default(require("dayjs/plugin/utc.js"));
const _nocodbsdk = require("nocodb-sdk");
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _datetimegeneralhandler = require("~/db/field-handler/handlers/date-time/date-time.general.handler");
const _catchError = require("~/helpers/catchError");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
_dayjs.default.extend(_utc.default);
_dayjs.default.extend(_timezone.default);
const dateHandlerDebug = (0, _debug.default)('nc:DateGeneralHandler');
let DateGeneralHandler = class DateGeneralHandler extends _datetimegeneralhandler.DateTimeGeneralHandler {
    async parseUserInput(params) {
        // Allow null/undefined values
        if ((0, _nocodbsdk.ncIsUndefined)(params.value) || params.value === null || params.value === '') {
            return {
                value: params.value
            };
        }
        let dayjsUtcValue;
        if (params.value instanceof Date || typeof params.value === 'number' || typeof params.value === 'string') {
            if (params.value instanceof Date) {
                dayjsUtcValue = (0, _dayjs.default)(params.value).utc();
            } else if (typeof params.value === 'string') {
                var _params_column_meta;
                dayjsUtcValue = (0, _dayjs.default)(params.value).utc();
                if (!dayjsUtcValue.isValid() && ((_params_column_meta = params.column.meta) == null ? void 0 : _params_column_meta.date_format)) {
                    var _params_column_meta1;
                    dayjsUtcValue = (0, _dayjs.default)(params.value, (_params_column_meta1 = params.column.meta) == null ? void 0 : _params_column_meta1.date_format).utc();
                }
            } else if (typeof params.value === 'number') {
                dayjsUtcValue = _dayjs.default.unix(params.value).utc();
            }
        }
        if (!dayjsUtcValue || !dayjsUtcValue.isValid()) {
            _catchError.NcError.invalidValueForField({
                value: params.value,
                column: params.column.title,
                type: params.column.uidt
            });
        }
        return {
            value: params.value
        };
    }
    comparisonBetween({ sourceField, anchorDate, rangeDate, qb }, { knex }, _options) {
        dateHandlerDebug('comparisonBetween ' + anchorDate.format(this.dateValueFormat) + ' - ' + rangeDate.format(this.dateValueFormat));
        qb.where(knex.raw('?? between ? and ?', [
            sourceField,
            anchorDate.format(this.dateValueFormat),
            rangeDate.format(this.dateValueFormat)
        ]));
    }
    comparisonOp({ sourceField, val, qb, comparisonOp }, { knex }, _options) {
        dateHandlerDebug('comparisonOp ' + val.format(this.dateValueFormat));
        qb.where(knex.raw(`?? ${comparisonOp} ?`, [
            sourceField,
            val.format(this.dateValueFormat)
        ]));
    }
    filterByOperation(operation) {
        async function applyFilter(args, rootArgs, _options) {
            const anchorDate = (0, _dayjs.default)(args.val).tz(this.getTimezone(rootArgs.knex, rootArgs.filter, rootArgs.column, _options));
            dateHandlerDebug('filterByOperation ' + operation + ' anchorDate ' + anchorDate.format(this.dateValueFormat));
            return {
                rootApply: undefined,
                clause: (qb)=>{
                    qb.where((nestedQb)=>{
                        this.comparisonOp(_extends({}, args, {
                            val: anchorDate,
                            qb: nestedQb,
                            comparisonOp: operation
                        }), rootArgs, _options);
                    });
                }
            };
        }
        return applyFilter.bind(this);
    }
    async filterEq(args, rootArgs, _options) {
        return this.filterByOperation('=')(args, rootArgs, _options);
    }
    async filterNeq(args, rootArgs, _options) {
        const anchorDate = (0, _dayjs.default)(args.val).tz(this.getTimezone(rootArgs.knex, rootArgs.filter, rootArgs.column, _options));
        dateHandlerDebug('filterNeq anchorDate ' + anchorDate.format(this.dateValueFormat));
        return {
            rootApply: undefined,
            clause: (qb)=>{
                // is earlier than anchor date
                // or later than range date
                // or null
                qb.where((nestedQb)=>{
                    this.comparisonOp(_extends({}, args, {
                        val: anchorDate,
                        qb: nestedQb,
                        comparisonOp: '!='
                    }), rootArgs, _options);
                    nestedQb.orWhereNull(args.sourceField);
                });
            }
        };
    }
    async filterGt(args, rootArgs, _options) {
        return this.filterByOperation('>')(args, rootArgs, _options);
    }
    async filterGte(args, rootArgs, _options) {
        return this.filterByOperation('>=')(args, rootArgs, _options);
    }
    async filterLt(args, rootArgs, _options) {
        return this.filterByOperation('<')(args, rootArgs, _options);
    }
    async filterLte(args, rootArgs, _options) {
        return this.filterByOperation('<=')(args, rootArgs, _options);
    }
    constructor(...args){
        super(...args), this.dateValueFormat = 'YYYY-MM-DD';
    }
};
